import { addDays, isSameDay, OwaDate, today } from 'owa-datetime';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';

/**
 * Returns appropriate string if the input date is today or tomorrow
 */
export function getRelativeDayString(date: OwaDate): string {
    const strings = getOwaMiniCommonStrings();
    const todayDate = today();
    if (isSameDay(date, todayDate)) {
        return strings.today;
    } else if (isSameDay(date, addDays(todayDate, 1))) {
        return strings.tomorrow;
    } else if (isSameDay(date, addDays(todayDate, -1))) {
        return strings.yesterday;
    }
    return null;
}
